/*
 *
 * Settings constants
 *
 */

// LOAD
export const LOAD_SETTINGS = 'app/Settings/LOAD_SETTINGS';
export const LOAD_SETTINGS_SUCCESS = 'app/Settings/LOAD_SETTINGS_SUCCESS';
export const LOAD_SETTINGS_ERROR = 'app/Settings/LOAD_SETTINGS_ERROR';

// CHANGE/UPDATE
export const CHANGE_SETTINGS = 'app/Settings/CHANGE_SETTINGS';
export const CHANGE_SETTINGS_SUCCESS = 'app/Settings/CHANGE_SETTINGS_SUCCESS';
export const CHANGE_SETTINGS_ERROR = 'app/Settings/CHANGE_SETTINGS_ERROR';

// DELETE
export const DELETE_SETTINGS = 'app/Settings/DELETE_SETTINGS';
export const DELETE_SETTINGS_SUCCESS = 'app/Settings/DELETE_SETTINGS_SUCCESS';
export const DELETE_SETTINGS_ERROR = 'app/Settings/DELETE_SETTINGS_ERROR';

export const FLUSH_STATE_SETTINGS = 'app/Settings/FLUSH_STATE_SETTINGS';
